import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Stethoscope: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}.st2{fill:#ff612b}'}</style>
    <g id="Layer_1">
      <path
        d="M12.625 6.667V4.5"
        style={{
          fill: '#273370',
        }}
      />
      <path
        d="M34.292 34.292a7.042 7.042 0 0 1-14.084 0V25.02c4.875-.54 8.667-4.668 8.667-9.687h-2.167c0 4.182-3.402 7.584-7.583 7.584s-7.583-3.402-7.583-7.584H9.375c0 5.019 3.792 9.147 8.667 9.687v9.272c0 5.077 4.13 9.208 9.208 9.208 5.077 0 9.208-4.13 9.208-9.208V30.5h-2.166v3.792zM24.542 6.667h1.083V4.5h-1.083a1.083 1.083 0 0 0 0 2.167zM14.792 5.583c0-.598-.485-1.083-1.084-1.083h-1.083v2.167h1.083c.599 0 1.084-.485 1.084-1.084z"
        className="st1"
      />
      <path
        d="M9.375 6.668v8.665h2.167V6.667h1.083V4.5h-1.082c-1.197 0-2.168.97-2.168 2.168zM26.708 4.5h-1.083v2.167h1.083v8.666h2.167V6.668c0-1.197-.97-2.167-2.167-2.168zM35.375 21.833a3.241 3.241 0 0 0-1.083 6.301V30.5h2.166v-2.366a3.241 3.241 0 0 0-1.083-6.3zm0 4.334a1.083 1.083 0 1 1 0-2.167 1.083 1.083 0 0 1 0 2.167z"
        className="st2"
      />
      <circle
        cx={35.375}
        cy={25.083}
        r={1.083}
        style={{
          fill: '#fff',
        }}
      />
    </g>
  </Box>
)
export default Stethoscope
